/**
 * @generated SignedSource<<41e21ad1f9f3b4f1bfffec8127a526d7>>
 * @relayHash aeed195db5e552c8aa8a4a961f295bca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b49810a1e13060d24800793b9ea16183a41f90ade7f30b9df6207119448a2c38

import type { ConcreteRequest, Query } from 'relay-runtime';
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$variables = {
  helpCenterAri: string;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly widgets: ReadonlyArray<{
      readonly __typename: string;
    } | null | undefined> | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery = {
  response: HelpCenterSettingsEmbeddedWidgetsAppQuery$data;
  variables: HelpCenterSettingsEmbeddedWidgetsAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EMBED"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              },
              (v4/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b49810a1e13060d24800793b9ea16183a41f90ade7f30b9df6207119448a2c38",
    "metadata": {},
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0aea35204e01d4e3ad1f7567fe257e63";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
